import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // For navigation to Login and Signup pages
import '../LandingPage.css'; // Add any specific styles if required

const LandingPage = () => {
    const [typedText, setTypedText] = useState('');
  const fullText = 'Wrrite Once Use Anywhere';

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
        if (index < fullText.length) {
            setTypedText((prevText) => prevText + fullText.charAt(index));
            index += 1;
          } else {
            clearInterval(interval); // Stop when the entire text has been typed
          }
    }, 150); // Adjust typing speed (150ms between letters)
    
    return () => clearInterval(interval); // Clean up on component unmount
  }, []);

  return (
    <div className="landing-container">
      <h1 className="landing-title">Welcome to AddressKeeper</h1>
      <p className="landing-description">
        AddressKeeper is a simple application to store and manage your personal addresses. 
        Easily add, fetch, and manage addresses with just a few clicks.
      </p>
      <p className="landing-description">
        {typedText}
      </p>
      <div className="landing-action-buttons">
        <Link to="/login" className="landing-button login-button">
          Login
        </Link>
        <Link to="/auth/signup" className="landing-button signup-button">
          Register
        </Link>
      </div>
    </div>
  );
};

export default LandingPage;
